import { IDataPoint } from '@principle-theorem/reporting';
import { type ChartBuilder } from './chart-builder';

export interface IChartCard {
  title: string;
  chartBuilder: ChartBuilder;
  unit?: string;
  value?: IDataPoint;
  summary?: string;
}
